export const dateTimeLongWithTimeZone = 'MMMM DD, YYYY hh:mm a Z';
export const dateLong = 'MMMM Do, YYYY';
export const dateMonthYear = 'MMMM DD, YYYY';
export const dateTime = 'MM-DD-YY HH:MM a';
export const referAFriendExp = '2023-08-31 23:59:59';
